export default "__VITE_ASSET__BRZnEEZG__"